import { Component, OnInit } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  constructor(public translateService: TranslocoService) {}
  language = "English";
  doc = "/assets/Privacy-Policy-French.pdf";
  ngOnInit(): void {}

  changeLanguage() {
    console.log(this.translateService.getActiveLang());
    if (this.language == "Francais") {
      this.translateService.setActiveLang("fr");
      this.doc = "/assets/Privacy-Policy-French.pdf";
      this.language = "English";
    } else {
      this.translateService.setActiveLang("en");
      this.language = "Francais";
      this.doc = "/assets/Privacy-Policy-English.pdf";
    }
  }
}
